import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import OnVisualizationConfigChangeContext from "views/components/aggregationwizard/OnVisualizationConfigChangeContext";
const Container = styled.div`
  height: 100%;
  flex: 3;
`;
const VisualizationContainer = ({ children }) => {
  const { setFieldValue, values } = useFormikContext();
  const onVisualizationConfigChange = useCallback(
    (newVisualizationConfig) => {
      setFieldValue("visualization", {
        ...values.visualization,
        config: { ...values.visualization.config, ...newVisualizationConfig }
      });
    },
    [values.visualization, setFieldValue]
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(OnVisualizationConfigChangeContext.Provider, { value: onVisualizationConfigChange }, children));
};
export default VisualizationContainer;
